import React from 'react';
import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/Nav';
import NavItem from 'react-bootstrap/NavItem';
import NavLink from 'react-bootstrap/NavLink';
import Tab from 'react-bootstrap/Tab';
import { SELECTION_EVENT, trackUserEvent } from 'userActivityMiddleware';
import LoadingIndicator from 'components/LoadingIndicator/index';
import { errorShape, patronStatusShape, userShape } from 'utils/shapes';
import { ACCOUNT_TYPE } from '../profileUtils';
import ProfileCMPCard from './ProfileCMPCard';
import ProfilePLSCard from './ProfilePLSCard';
import './ProfileLoyaltyInfo.css';

function ProfileLoyaltyInfo({
  userData,
  cmpStatusData,
  plsStatusData,
  onAccountTypeChange,
  activeAccountType
}) {
  const handleTabSelect = tab => {
    if (tab === ACCOUNT_TYPE.CMP_ACCOUNT) {
      trackUserEvent({
        activityType: SELECTION_EVENT,
        eventName: 'toggle-profile-card-to-CMP',
        eventValue: ACCOUNT_TYPE.CMP_ACCOUNT,
        initiator: 'profile-loyalty-slider'
      });
      onAccountTypeChange(ACCOUNT_TYPE.CMP_ACCOUNT);
    } else if (tab === ACCOUNT_TYPE.PLS_ACCOUNT) {
      trackUserEvent({
        activityType: SELECTION_EVENT,
        eventName: 'toggle-profile-card-to-PLS',
        eventValue: ACCOUNT_TYPE.PLS_ACCOUNT,
        initiator: 'profile-loyalty-slider'
      });
      onAccountTypeChange(ACCOUNT_TYPE.PLS_ACCOUNT);
    }
  };

  if (userData?.loading) {
    return <LoadingIndicator />;
  }

  if (userData?.error) {
    return (
      <div className="alert alert-danger">
        Failed to retrieve player info. Please contact support.
      </div>
    );
  }

  const hasCMPData = !!cmpStatusData;
  const hasPLSData = !!plsStatusData;

  return (
    <div className="profile-loyalty-container">
      <Tab.Container activeKey={activeAccountType} onSelect={handleTabSelect}>
        {hasCMPData && hasPLSData && (
          <Nav className="profile-loyalty-slider" variant="pills">
            <NavItem className="profile-nav nav-1">
              <NavLink eventKey={ACCOUNT_TYPE.CMP_ACCOUNT}></NavLink>
            </NavItem>
            <NavItem className="profile-nav nav-2">
              <NavLink eventKey={ACCOUNT_TYPE.PLS_ACCOUNT}></NavLink>
            </NavItem>
          </Nav>
        )}
        <Tab.Content>
          {hasCMPData && (
            <Tab.Pane eventKey={ACCOUNT_TYPE.CMP_ACCOUNT}>
              <ProfileCMPCard user={userData?.user} cmpStatus={cmpStatusData} />
            </Tab.Pane>
          )}
          {hasPLSData && (
            <Tab.Pane eventKey={ACCOUNT_TYPE.PLS_ACCOUNT}>
              <ProfilePLSCard user={userData?.user} plsStatus={plsStatusData} />
            </Tab.Pane>
          )}
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}

ProfileLoyaltyInfo.propTypes = {
  userData: PropTypes.shape({
    user: userShape,
    loading: PropTypes.bool,
    error: errorShape
  }),
  statusData: PropTypes.shape({
    patronAssets: PropTypes.shape({
      tickets: PropTypes.number,
      wscore: PropTypes.number,
      sapphires: PropTypes.number
    }),
    status: patronStatusShape,
    loading: PropTypes.bool,
    error: errorShape
  })
};

export default ProfileLoyaltyInfo;
